module.exports = __webpack_public_path__ + "static/media/cd2-icon-info.f7cbfffd.svg";